import React, { useRef, useEffect, useState } from 'react'
import ProgressiveImg from '../components/ProgressiveImg';
import FindAgentBlock from '../components/FindAgentBlock';
import { InView } from 'react-intersection-observer';

import '../assets/styles/pages/_about-history.scss'
import { throttle } from "lodash";


export const AboutHistory = () => {
  const [view1900, set1900] = React.useState(false)
  const [view1930, set1930] = React.useState(false)
  const [view1940, set1940] = React.useState(false)
  const [view1950, set1950] = React.useState(false)
  const [view1970, set1970] = React.useState(false)
  const [view1980, set1980] = React.useState(false)
  const [view1990, set1990] = React.useState(false)
  const [view2000, set2000] = React.useState(false)
  const [view2020, set2020] = React.useState(false)

  const y1900 = useRef(null);
  const y1930 = useRef(null);
  const y1940 = useRef(null);
  const y1950 = useRef(null);
  const y1970 = useRef(null);
  const y1980 = useRef(null);
  const y1990 = useRef(null);
  const y2000 = useRef(null);
  const y2020 = useRef(null);

  const years = [
    { id: 0, ref: y1900, name: "decade", value: "1900's", isChecked: view1900 },
    { id: 1, ref: y1930, name: "decade", value: "1930's", isChecked: view1930 },
    { id: 2, ref: y1940, name: "decade", value: "1940's", isChecked: view1940 },
    { id: 3, ref: y1950, name: "decade", value: "1950's", isChecked: view1950 },
    { id: 4, ref: y1970, name: "decade", value: "1970's", isChecked: view1970 },
    { id: 5, ref: y1980, name: "decade", value: "1980's", isChecked: view1980 },
    { id: 6, ref: y1990, name: "decade", value: "1990's", isChecked: view1990 },
    { id: 7, ref: y2000, name: "decade", value: "2000's", isChecked: view2000 },
    { id: 8, ref: y2020, name: "decade", value: "2020's", isChecked: view2020 }
  ]


  const [yearsState, setYears] =  useState(years);
  const [modalImage, setModalImage] =  useState(false);
  const [modalImageTitle, setModalImageTitle] =  useState(false);

  const modalImageOpen = (image, title) => {
    setModalImage(image);
    setModalImageTitle(title);
  }

  const getYear = () => {
    return new Date().getFullYear()
  }

  useEffect(()=>{
    setYears(years);
  },[
    view1900,
    view1930,
    view1940,
    view1950,
    view1970,
    view1980,
    view1990,
    view2000,
    view2020
  ]);

  const scrollToItem = (ref) => {
    ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  return (
    <>
      <div className="about-history-page" >
        <div className="header-block">
          <ProgressiveImg
            lowQualitySrc={ `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-right.png`}
            highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-right.svg`}
            className="right-picture"
          />
          <ProgressiveImg
            lowQualitySrc={ `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-center.png`}
            highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-center.svg`}
            className="center-picture"
          />
          <ProgressiveImg
            lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-left.png`}
            highQualitySrc={ `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/first-block-left.svg`}
            className="left-picture"
          />
          <div className="title">
            Our Story
          </div>
        </div>

        <div className="main-block">
          <main style={{position: 'relative'}}>
            <aside>
              <ul>
                {
                  yearsState.map(item => {
                    return (
                        <li key={item.id} className={item.isChecked ? 'active' : ''} >
                          <input
                              type="checkbox"
                              name={item.name}
                              id={item.value}
                              checked={item.isChecked}
                              readOnly={true}
                          />
                          <label htmlFor={item.value} onClick={(event) => scrollToItem(item.ref, event)}>
                            <div className='check-box'/>
                            {item.value}
                          </label>
                        </li>
                    )
                  })
                }
              </ul>
            </aside>
            <div className="list-container">
              <div className="year-section">
                <InView className="year-section__view-trigger" id="1900's"  onChange={set1900}/>
                <div className="list-section section-1900" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1900}/>
                    1901
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Our beginnings
                    </div>
                    <div className="list-section__text">
                      Nine Czech-Americans met at the local general store in the small farming community of Ocker, Texas.  They emerged from the meeting with a plan to protect each other from the potential financial disaster they would experience if their properties were damaged or destroyed through fire or storm.  They realized they could pool their resource to provide each other with mutual assistance in the event of a loss by a member.
                    </div>
                    <div className="list-section__image-link">
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture1.png`} alt="" />
                    </div>
                    <div className="sub-block-1">
                      <div className="list-section__image-link">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture2.png`} alt="" />
                      </div>
                      <div className="list-section__description">
                        Soon thereafter, Rolnický Vzájemně Ochranný Spolek Statu Texas (RVOS), a non-profit farm mutual insurance association, was formed.  This fledgling company soon became commonly known by the English translation of its original Czech name, Farmers Mutual Protective Association of Texas.
                      </div>
                    </div>
                    <div className="sub-block-2">
                      <div className="list-section__col">
                        <div className="list-section__description">
                          The Articles of Incorporation were completed and a special meeting was held to adopt the Association’s bylaws and elect its officers.
                        </div>
                        <div className="list-section__description">
                          To this day, RVOS membership is comprised of each person whose property is accepted and insured through the Association.
                        </div>
                      </div>
                      <div className="list-section__image-link clickable"
                           onClick={() => modalImageOpen(
                               `${process.env.REACT_APP_MY_API_KEY}/rvos-graphics/assets/img/about/history/large-images/rvos-docs.jpg`,
                               ' The Association\'s by-laws in Czech language')}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture3.png`} alt="" />
                      </div>
                    </div>
                    <div className="list-section__title title2">
                      First year
                    </div>
                    <div className="list-section__text">
                      By the end of 1901, membership had grown from the original nine members, with $12,816 total insurance coverage, to 416 members, with $217,512 of coverage.
                    </div>
                  </div>
                </div>
                <div className="list-section section-1902">
                  <div className="list-section__heading white">1902</div>
                  <div className="list-section__body">
                    <div className="list-section__title white">
                      First lodges created
                    </div>
                    <div className="list-section__text white">
                      To represent the Association’s members in their respective communities, local lodges were formed.
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section">
                <InView className="year-section__view-trigger" id="1930's"   onChange={set1930}/>
                <div className="list-section section-1933" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1930}/>
                    1933
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      New Insurance Opportunities
                    </div>
                    <div className="list-section__subtitle">
                      Insurance was permitted on property located within city limits.
                    </div>
                    <div className="list-section__row">
                      <div className="list-section__text columned">
                        <p>The 1933 General Convention ushered in an era of opportunity for the Association's members.  Property located within the city limits became insurable. Before this, only rural properties were eligible for coverage.</p>
                        <p>Originally, perpetual policies had been issued and were effective as long as the members paid their premiums.  However, experience in the 1930s revealed many of the properties were over-insured, and regular reappraisals of the properties were necessary.  This convention amended the bylaws to allow for the issuance of 5-year policies, whereupon the properties would be reappraised before renewal.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="1940's"   onChange={set1940}/>
                <div className="list-section section-1946" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1940}/>
                    1946
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__col">
                      <div className="list-section__title">
                        Operations Centralized
                      </div>
                      <div className="list-section__text">
                        Association Officers were required to live locally and work directly from their own homes until 1946 when the General Convention authorized the creation of a Home Office. For the first time, daily operations were centralized and handled out of the same office.
                      </div>
                    </div>
                    <div className="list-section__image">
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture4.png`} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="1950's"  onChange={set1950}/>
                <div className="list-section section-1950" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1950}/>
                    1950
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      The first Home Office
                    </div>
                    <div className="list-section__image">
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture6.png`} alt="" />
                    </div>
                    <div className="list-section__text">
                      The first home office building was built at 20 South 4th Street in Temple, Texas.
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="1970's"  onChange={set1970}/>
                <div className="list-section section-1974" >
                  <div className="list-section__heading white">
                    <div className="year-section__ref" ref={y1970}/>
                    1974
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title white">
                      One convenient policy
                    </div>
                    <div className="list-section__text white">
                      Coverages were combined into one policy. Members were no longer issued and billed separate policies for fire, lightning, theft, or coverage extensions.
                    </div>
                    <div className="list-section__image">
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture7.png`} alt="" />
                    </div>
                  </div>
                </div>
                <div className="list-section section-1979">
                  <div className="list-section__heading">1979</div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Subsidiary established
                    </div>
                    <div className="list-section__text">
                      The Association formed a wholly-owned subsidiary, Texas RVOS Insurance Company, to provide liability coverage for its members.
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="1980's"  onChange={set1980}/>
                <div className="list-section section-1981" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1980}/>
                    1981
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Relocation
                    </div>
                    <div className="list-section__text">
                      The RVOS Home Office moved to its present location at 2301 South 37th Street, Temple, Texas.
                    </div>
                    <div className="list-section__image">
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture8.png`} alt="" />
                    </div>
                  </div>
                </div>
                <div className="list-section section-1987">
                  <div className="list-section__heading">1987</div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Texas Historical Marker
                    </div>
                    <div className="list-section__row">
                      <div className="list-section__image-link clickable"
                           onClick={() => modalImageOpen(
                          `${process.env.REACT_APP_MY_API_KEY}/rvos-graphics/assets/img/about/history/large-images/rvos-marker.jpg`,
                          'Texas Historical Marker')}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture9.png`} alt="" />
                      </div>
                      <div className="list-section__text">
                        A Texas Historical Marker was dedicated to commemorate the founding of
                        Farmers Mutual Protective Association of Texas. The dedication ceremony took place at the marker site,
                        located at FM 2904 and Highway 320, in East Bell County.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="1990's"  onChange={set1990}/>
                <div className="list-section section-1999" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y1990}/>
                    1999
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      RVOS General Agency formed
                    </div>
                    <div className="list-section__text">
                      RVOS formed RVOS General Agency, Inc., to provide a variety of new coverage options requested by its membership.
                    </div>
                    <div className="list-section__text">
                      The agency continues to be a competitive resource for automobile, flood, life, mobile and motor home, watercraft, and ATV coverages.
                    </div>
                  </div>
                </div>
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="2000's"  onChange={set2000}/>
                <div className="list-section section-2000" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y2000}/>
                    2000
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Subsidiary name change
                    </div>
                    <div className="list-section__row">
                      <div className="list-section__col">
                        <div className="list-section__text">
                          The name of Texas RVOS Insurance Company was changed to Priority One Insurance Company.
                        </div>
                      </div>
                      <div className="list-section__image">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture10.png`} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 2008 section removed (NCIC) */}
              </div>
              <div className="year-section" >
                <InView className="year-section__view-trigger" id="2020's"  onChange={set2020}/>
                <div className="list-section section-2021" >
                  <div className="list-section__heading">
                    <div className="year-section__ref" ref={y2020}/>
                    2021
                  </div>
                  <div className="list-section__body">
                    <div className="list-section__col">
                      <div className="list-section__title">
                        State of Texas commemoration
                      </div>
                      <div className="list-section__text">
                        The House of Representatives of the 87th Texas Legislature issued a resolution to commemorate RVOS Farm Mutual Insurance Company for its rich history and many achievements upon the 120th anniversary of its founding."
                      </div>
                    </div>
                    <div className="list-section__image clickable"
                         onClick={() => modalImageOpen(
                        `${process.env.REACT_APP_MY_API_KEY}/rvos-graphics/assets/img/about/history/large-images/rvos-resolution.jpg`,
                        'Resolution')}>
                      <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/history/picture12.png`} alt="" />
                    </div>
                  </div>
                </div>
                <div className="list-section section-2021-2">
                  <div className="list-section__heading">{getYear()}</div>
                  <div className="list-section__body">
                    <div className="list-section__title">
                      Neighbors Helping Neighbors
                    </div>
                    <div className="list-section__text">
                      RVOS Farm Mutual Insurance Company, Priority One Insurance, and the RVOS General Agency continue
                      to focus on providing exceptional products and services to meet the ever-changing needs of our policyholders.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <FindAgentBlock />
        </div>
      </div>
    </>
  );
}
